import * as _ from 'lodash';
import { formValueSelector } from 'redux-form';

export const FORM_NAME = 'specialtyVehicle';

// set destroyOnUnmount / forceUnregisterOnUnmount because the specialty vehicle loan form
// spans multiple pages: https://redux-form.com/6.6.3/examples/wizard/
// and set enableReinitialize so we reset initial values even when the
// user goes down a path, clicks back, and goes down a different one
export const FORM_CONFIG = {
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  form: FORM_NAME,
};

export type SpecialtyVehicleFormField = 'specialtyVehicleCategory' | 'autoLoanPurposeType';
export type SpecialtyVehicleModelProperties = { [key in SpecialtyVehicleFormField]?: string };

export const FIELDS: { [key in SpecialtyVehicleFormField]: SpecialtyVehicleFormField } = {
  specialtyVehicleCategory: 'specialtyVehicleCategory',
  autoLoanPurposeType: 'autoLoanPurposeType',
};

export const selector = formValueSelector(FORM_NAME);

export function getModelProperties(state: ReduxState) {
  if (state.form[FORM_NAME]) {
    // if we've gone through specialty vehicle onboarding, manually build an object with
    // values, albeit only truthy values because /api/borrowers complains if
    // we send a null (but do return undefined if no values are saved)
    const modelProperties = _.pickBy(
      _.mapValues(FIELDS, field => selector(state, field)),
    ) as SpecialtyVehicleModelProperties;

    if (!_.isEmpty(modelProperties)) {
      return modelProperties;
    }
  }
}

export function getSpecialtyVehicleCategory(state: ReduxState) {
  return selector(state, FIELDS.specialtyVehicleCategory);
}

export function getAutoLoanPurposeType(state: ReduxState) {
  return selector(state, FIELDS.autoLoanPurposeType);
}
